import { render, staticRenderFns } from "./DomainDetail.vue?vue&type=template&id=644cf2f3"
import script from "./DomainDetail.vue?vue&type=script&lang=js"
export * from "./DomainDetail.vue?vue&type=script&lang=js"
import style0 from "./DomainDetail.vue?vue&type=style&index=0&id=644cf2f3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports